const resolveErrorField = key => {
  const [
    // application, // eslint-disable-line no-unused-vars
    section,
    field,
    subfield
  ] = key.split('.');
  return { section, field, subfield };
};

const parseServerValidationError = errors =>
  Object.entries(errors).reduce((errorObject, [key, value]) => {
    const { section, field, subfield } = resolveErrorField(key);
    const errorObjectSection = errorObject[section] || {};

    if (subfield)
      return {
        ...errorObject,
        [section]: {
          ...errorObjectSection,
          [field]: {
            ...(errorObjectSection[field] || {}),
            [subfield]: { error: value }
          }
        }
      };
    return {
      ...errorObject,
      [section]: {
        ...(errorObject[section] || {}),
        [field]: { error: value }
      }
    };
  }, {});

export default parseServerValidationError;
